export const GET_DASHBOARD_USER_COUNT = "GET_DASHBOARD_USER_COUNT";
export const GET_DASHBOARD_USER_COUNT_RES = "GET_DASHBOARD_USER_COUNT_RES";
export const RESPONSE_STATUS = "RESPONSE_STATUS";
export const GET_FEEDBACK = "GET_FEEDBACK";
export const FEEDBACK_STATUS = "FEEDBACK_STATUS";
export const FEEDBACK_LOADER_STATUS_UPDATE = "FEEDBACK_LOADER_STATUS_UPDATE";
